export class Media {
    urls: string[];
    media: string[];

    constructor(urls: string[], media: string[]) {
        this.urls = urls;
        this.media = media;
    }
}

export class Campaign {
    id: number;
    title: string;
    nickname: string;
    adStatus: string | null;
    approvalStatus: string | null;
    adminMsg: string;
    media: Media;
    startTime: number;
    endTime: number;

    objective: number;
    dailyBudget: string;
    ageMin: string | null;
    ageMax: string | null;
    hittingHand: string | null;
    throwingHand: string | null;
    positions: string[] | null;
    country: string | null;
    state: string | null;
    city: string | null;
    headline: string | null;
    link: string | null;
    templateId: number;

    impressions: number | null;
    clicks: number | null;
    conversions: number | null;
    spend: number | null;
    qualityImpressions: number | null;

    constructor(
        id: number,
        title: string,
        nickname: string,
        adStatus: string | null,
        approvalStatus: string | null,
        adminMsg: string,
        media: Media,
        startTime: number,
        endTime: number,
        objective: number,
        dailyBudget: string,
        ageMin: string | null,
        ageMax: string | null,
        hittingHand: string | null,
        throwingHand: string | null,
        positions: string[] | null,
        country: string | null,
        state: string | null,
        city: string | null,
        headline: string | null,
        link: string | null,
        templateId: number,
        impressions: number | null = null,
        clicks: number | null = null,
        conversions: number | null = null,
        spend: number | null = null,
        qualityImpressions: number | null = null,
    ) {
        this.id = id;
        this.title = title;
        this.nickname = nickname;
        this.adStatus = adStatus;
        this.approvalStatus = approvalStatus;
        this.adminMsg = adminMsg;
        this.media = media;
        this.startTime = startTime;
        this.endTime = endTime;
        this.objective = objective;
        this.dailyBudget = dailyBudget;
        this.ageMin = ageMin;
        this.ageMax = ageMax;
        this.hittingHand = hittingHand;
        this.throwingHand = throwingHand;
        this.positions = positions;
        this.country = country;
        this.state = state;
        this.city = city;
        this.headline = headline;
        this.link = link;
        this.templateId = templateId;
        this.impressions = impressions;
        this.clicks = clicks;
        this.conversions = conversions;
        this.spend = spend;
        this.qualityImpressions = qualityImpressions;
    }
}

export class CampaignPerformance {
    impressions: number;
    clicks: number;
    qualityImpressions: number;
    platformImpressions: { [key: string]: number };
    countryImpressions: { [key: string]: number };

    constructor(
        impressions: number,
        clicks: number,
        qualityImpressions: number,
        platformImpressions: { [key: string]: number },
        countryImpressions: { [key: string]: number },
    ) {
        this.impressions = impressions;
        this.clicks = clicks;
        this.qualityImpressions = qualityImpressions;
        this.platformImpressions = platformImpressions;
        this.countryImpressions = countryImpressions;
    }
}
